import { render, staticRenderFns } from "./FeatureEventCarousel.vue?vue&type=template&id=5431e1c6&scoped=true&"
import script from "./FeatureEventCarousel.vue?vue&type=script&lang=js&"
export * from "./FeatureEventCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FeatureEventCarousel.vue?vue&type=style&index=0&id=5431e1c6&lang=scss&scoped=true&"
import style1 from "./FeatureEventCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431e1c6",
  null
  
)

export default component.exports